import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

interface Props {
  show: boolean;
  onConfirm: (motivo: string) => Promise<void>;
  onCancel: () => void;
}

const ModalSolicitudReject: React.FC<Props> = ({ show, onConfirm, onCancel }) => {
  const [motivo, setMotivo] = useState('');
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setMotivo('');
    onCancel();
  };

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm(motivo);
      setMotivo('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title><i className="bi bi-exclamation-triangle-fill text-warning fs-1 mt-1"></i> Rechazar Solicitud</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-8">
          <p className="mb-0">
            Al confirmar el rechazo, usted regresará esta solicitud al área de Relaciones Médicas, ¿está segura/o?
          </p>
        </div>

        <Form.Group>
          <Form.Label className="fw-bold">
            Ingrese motivo de rechazo
            <span className="text-danger ms-1">*</span>
          </Form.Label>
          <Form.Text className="text-muted d-block mb-2">
            Para confirmar el rechazo debe ingresar el motivo.
          </Form.Text>
          <Form.Control
            as="textarea"
            rows={4}
            value={motivo}
            onChange={(e) => setMotivo(e.target.value)}
            placeholder="Describa el motivo del rechazo..."
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
          variant="danger"
          onClick={handleConfirm}
          disabled={motivo.trim() === '' || loading}
        >
          {loading && <span className="spinner-border spinner-border-sm me-2"></span>}
          Confirmar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalSolicitudReject;
